// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
    background-color: black;
}

.admin-dashboard {
    font-family: Arial, sans-serif;
    padding: 20px;
    background-color: #000; /* Set background color to black */
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    color: #fff; /* Set text color to white for better contrast */
    min-height: 100vh; /* Ensure it takes the full height of the viewport */
}

.admin-title {
    color: #fff; /* Set heading color to white */
    margin-bottom: 20px;
}

.go-to-chat-button {
    display: inline-block;
    margin-bottom: 20px;
    padding: 10px 20px;
    background-color: #10a37f;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.25s ease;
}

.go-to-chat-button:hover {
    background-color: #0e8f6d;
}

.loading {
    font-size: 18px;
    color: #888;
}

.error {
    color: red;
    font-size: 16px;
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Admin.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,sBAAsB,EAAE,kCAAkC;IAC1D,kBAAkB;IAClB,wCAAwC;IACxC,WAAW,EAAE,gDAAgD;IAC7D,iBAAiB,EAAE,oDAAoD;AAC3E;;AAEA;IACI,WAAW,EAAE,+BAA+B;IAC5C,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB","sourcesContent":[".app {\n    background-color: black;\n}\n\n.admin-dashboard {\n    font-family: Arial, sans-serif;\n    padding: 20px;\n    background-color: #000; /* Set background color to black */\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    color: #fff; /* Set text color to white for better contrast */\n    min-height: 100vh; /* Ensure it takes the full height of the viewport */\n}\n\n.admin-title {\n    color: #fff; /* Set heading color to white */\n    margin-bottom: 20px;\n}\n\n.go-to-chat-button {\n    display: inline-block;\n    margin-bottom: 20px;\n    padding: 10px 20px;\n    background-color: #10a37f;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.25s ease;\n}\n\n.go-to-chat-button:hover {\n    background-color: #0e8f6d;\n}\n\n.loading {\n    font-size: 18px;\n    color: #888;\n}\n\n.error {\n    color: red;\n    font-size: 16px;\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
